var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-items-center apply-block mb-2" },
    [
      _c("div", { staticClass: "mr-1" }, [_vm._v("\n    Apply to:\n  ")]),
      _vm._v(" "),
      _c("SelectTemplateDropdown", {
        attrs: {
          "local-storage-key":
            _vm.LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_BG_COLOR,
        },
      }),
      _vm._v(" "),
      _c(
        "b-dropdown",
        {
          ref: "propertiesDropdown",
          staticClass: "select-properties-dropdown mr-1",
          attrs: {
            size: "sm",
            variant: "primary",
            text: "Actions",
            "menu-class": "p-0",
          },
        },
        [
          _c(
            "b-list-group",
            [
              _vm._l(_vm.properties, function (property, index) {
                return _c(
                  "b-list-group-item",
                  { key: index },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "select-size",
                        attrs: { size: "sm" },
                        on: {
                          change: function ($event) {
                            return _vm.updateSelectedProperties(property)
                          },
                        },
                        model: {
                          value: property.value,
                          callback: function ($$v) {
                            _vm.$set(property, "value", $$v)
                          },
                          expression: "property.value",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(property.text) + "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "b-list-group-item",
                { staticClass: "d-flex justify-content-end" },
                [
                  _vm.selectedProperties.length
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { size: "sm", variant: "outlined" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.resetProperties.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("\n          Reset\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "primary",
                        disabled: !_vm.selectedProperties.length,
                      },
                      on: { click: _vm.apply },
                    },
                    [_vm._v("\n          Apply\n        ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ApplyInfoButton"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }